import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useDispatch } from "react-redux";
import Heading from "../../../../../../common/element/Heading/index.js";
import BtnLight from "../../../../../../common/element/Buttons/btnLight.js";
import Dropdown from "../../../../../../common/element/Dropdown/Dropdown.js";
import Label from "../../../../../../common/element/Label/index.js";
import Input from "../../../../../../common/element/Input/Input.js";
import { setBreadcrumbs } from "../../../../../../redux/classes/breadcrumbsSlice.js";
import Select from "../../../../../../common/element/Select/Select.js";
import Button from "../../../../../../common/element/Buttons/index.js";
import ClientOverviewList from "../ClientsOverview/ClientOverviewList.js";
import LineChart from "../ClientsOverview/chart.js";
import {
  GenerateClientInductionReport,
  TriggerClientInductionReport,
} from "../../../../../../actions/Admin-Client/reports/GenerateClientInductionReport.js";
import { GetWorkersForClientInductionReport } from "../../../../../../actions/Admin-Client/reports/GetWorkersForClientInductionReport";
// import PieChart from "../ProviderUnderAClient/PieChartUnderAClient.js";
import PieChart from "./PieChartUnderAClient.js";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ActivityGauge from "./ActivityGauge.js";
import ProgressCircle from "./ProgressCircle.js";
import ClientInductionList from "./ClientInductionList.js";
import { Pagination } from "../../../../../../common/pagination/index.js";
import useUnauthorizedHandler from "../../../../../../common/snippet/useUnauthorizedHandler.js";
import ThreeDotBouncing from "../../../../../../common/element/PageLoader/index.js";
import ThreeDotLoader from "../../../../../../common/element/ButtonLoader/ThreeDotLoader";
import MainOfficeStateMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/MainOfficeStateMultiSelectDropdown.js";
import { notify } from "react-notify-toast";
import ReactPaginate from "react-paginate";
import ClientMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/ClientMultiSelectDropdown.js";
import StatusMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/StatusMultiSelectDropdown.js";
import DateMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/DateMultiSelectDropdown.js";
import AllProviderMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/AllProviderMultiSelectDropdown.js";
import SiteMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/SiteMultiSelectDropdown.js";
import InductionMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/InductionMultiSelectDropdown.js";
import WorkerMultiSelectDropdown from "./WorkerMultiSelectDropdown";
import moment from "moment";
import { CSVLink } from "react-csv";
import logoPDF from "./LogoPDF.png";
import Dialog from "../../../../../../common/element/Dialog/Dialog.js";
import { GetAllProviderTypeList } from "../../../../../../actions/admin-provider/reports/GetAllProviderTypeList";
 
const ClientsInductions = () => {
  const csvLinkRef = useRef(null);
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const unauthorizedHandlerRef = useRef(handleUnauthorizedAccess);
  const dispatch = useDispatch();
  const [reportData, SetReportData] = useState(null);
  const [loadData, setLoadData] = useState(false);
  const [processedCsvData, setProcessedCsvData] = useState([]);
  const [checkPdfLoad, setCheckPdfLoad] = useState(true);
  const [successText, setSuccessText] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [key, setKey] = useState("custom");
  const [pdfDownloadSuccessDialog, setPdfDownloadSuccessDialog] =
    useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [rowWorkersState, setRowWorkersState] = useState({});
  const [providerTypesMap, setProviderTypesMap] = useState({});

  const [dateMinMax, setDateMinMax] = useState({
    lowestDate: null,
    greatestDate: null,
  });
  const [getAllinvitedData, SetgetAllinvitedData] = useState({
    search: "",
    client_org_ids: [],
    provider_org_ids: [],
    worker_ids: [],
    status: "",
    inductionType: "",
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    publish_date_range: "",
    com_ind_ids: [],
    site_ind_ids: [],
    state_ids: [],
    site_ids: [],
    expired_only: false,
    expiry_date_range: "",
  });

  useEffect(() => {
    const loadProviderTypes = async () => {
      try {
        const response = await dispatch(GetAllProviderTypeList());
        if (response?.success && Array.isArray(response?.data)) {
          const lookup = response.data.reduce((acc, item) => {
            const key = String(item?.provider_type_id ?? item?.id ?? "").trim();
            const label =
              item?.provider_type_name ??
              item?.provider_type_label ??
              item?.name ??
              item?.label ??
              "";
            if (key.length && label) {
              acc[key] = label;
            }
            return acc;
          }, {});
          setProviderTypesMap(lookup);
        }
      } catch (error) {
        console.error("Unable to load provider types", error);
      }
    };

    loadProviderTypes();
  }, [dispatch]);

  useEffect(() => {
    unauthorizedHandlerRef.current = handleUnauthorizedAccess;
  }, [handleUnauthorizedAccess]);

  const filtersKey = useMemo(
    () => JSON.stringify(getAllinvitedData),
    [getAllinvitedData]
  );

  const lastFiltersKeyRef = useRef(null);

  const fetchReportData = useCallback(
    async ({ forceRefresh = false } = {}) => {
      if (!forceRefresh && lastFiltersKeyRef.current === filtersKey) {
        return;
      }

      lastFiltersKeyRef.current = filtersKey;
      setLoadData(false);

      try {
        const response = await dispatch(
          GenerateClientInductionReport(getAllinvitedData)
        );

        setExpandedRows([]);
        setRowWorkersState({});

        if (response.success) {
          setLoadData(true);
          const normalisedReport = Array.isArray(
            response?.data?.inductionReport
          )
            ? response.data.inductionReport.map((row) => {
                const rawProviderType = (() => {
                  if (typeof row?.provider_type === "string") {
                    return row.provider_type.trim();
                  }
                  if (
                    row?.provider_type &&
                    typeof row.provider_type === "object"
                  ) {
                    return (
                      row.provider_type?.name ??
                      row.provider_type?.label ??
                      row.provider_type?.provider_type_name ??
                      row.provider_type?.providerTypeName ??
                      row.provider_type?.provider_type_label ??
                      ""
                    ).trim();
                  }
                  return "";
                })();

                const fallbackProviderType = (
                  row?.provider_type_name ??
                  row?.provider_type_label ??
                  row?.providerType ??
                  row?.providerTypeName ??
                  row?.provider_type_value ??
                  row?.provider_type_display ??
                  ""
                ).trim();

                const typeFromMap = providerTypesMap[
                  String(row?.provider_type_id ?? row?.providerTypeId ?? "").trim()
                ];

                const resolvedProviderType =
                  rawProviderType.length > 0
                    ? rawProviderType
                    : fallbackProviderType.length > 0
                    ? fallbackProviderType
                    : typeof typeFromMap === "string"
                    ? typeFromMap
                    : "";

                return {
                  ...row,
                  provider_type: resolvedProviderType,
                };
              })
            : [];

          SetReportData({
            ...response?.data,
            inductionReport: normalisedReport,
          });
          const timestamps = response?.data?.inductionReport?.map((product) =>
            new Date(product?.date_joined).getTime()
          );
          if (timestamps?.length) {
            const lowestDate = new Date(Math.min(...timestamps));
            const greatestDate = new Date(Math.max(...timestamps));
            setDateMinMax({ lowestDate, greatestDate });
          }
          setTotalPages(
            Math.ceil(response?.data?.total / getAllinvitedData?.limit)
          );
        } else if (response?.status === 401) {
          unauthorizedHandlerRef.current();
          setLoadData(true);
        } else {
          setLoadData(true);
        }
      } catch (error) {
        setLoadData(true);
        console.error("Unable to fetch client induction report", error);
      }
    },
    [
      dispatch,
      filtersKey,
      getAllinvitedData,
      providerTypesMap,
      unauthorizedHandlerRef,
    ]
  );

  useEffect(() => {
    fetchReportData();
  }, [fetchReportData]);

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Reports",
          url: "/admin/reports",
          home: "/admin/client/dashboard",
        },
        {
          label: "Clients Inductions",
          url: "/admin/client/reports/clients-inductions",
        },
      ])
    );
  }, [dispatch]);

  const handleSort = (empty, column) => {
    // if (column === getAllinvitedData.sort) {
    SetgetAllinvitedData((prevalue) => {
      return {
        ...prevalue,
        ["order"]: getAllinvitedData.order === "asc" ? "desc" : "asc",
        ["sort"]: column,
      };
    });
  };

  const normalisedWorkerIds = useMemo(() => {
    if (!Array.isArray(getAllinvitedData?.worker_ids)) {
      return [];
    }

    const cleaned = getAllinvitedData.worker_ids
      .map((raw) => {
        if (raw == null) {
          return null;
        }

        if (typeof raw === "object") {
          const candidate =
            raw?.worker_id ?? raw?.workerId ?? raw?.id ?? raw?.value ?? null;
          return candidate != null ? String(candidate).trim() : null;
        }

        return String(raw).trim();
      })
      .filter((value) => typeof value === "string" && value.length > 0);

    return Array.from(new Set(cleaned));
  }, [getAllinvitedData?.worker_ids]);

  const workerFilterKey = useMemo(() => JSON.stringify(normalisedWorkerIds), [normalisedWorkerIds]);

  const buildRowKey = useCallback((row) => {
    const parts = [
      row?.client_org_id ?? "client",
      row?.provider_org_id ?? "provider",
      row?.company_induction_id ?? row?.company_ind_id ?? "company",
      row?.site_induction_id ?? row?.site_ind_id ?? "site",
      row?.induction_id ?? row?.id ?? "induction",
    ];

    return parts.join("-");
  }, []);

  const fetchWorkersForRow = useCallback(
    async (rowKey, rowItem) => {
      const companyInductionId =
        rowItem?.company_induction_id ?? rowItem?.company_ind_id ?? null;
      const siteInductionId =
        rowItem?.site_induction_id ?? rowItem?.site_ind_id ?? null;

      const payload = {
        client_org_id: rowItem?.client_org_id,
        provider_org_id: rowItem?.provider_org_id,
        company_induction_id: companyInductionId,
        site_induction_id: siteInductionId,
        provider_type: rowItem?.provider_type,
      };

      if (normalisedWorkerIds.length) {
        payload.worker_ids = JSON.stringify(normalisedWorkerIds);
      }

      setRowWorkersState((prev) => ({
        ...prev,
        [rowKey]: {
          data: prev[rowKey]?.data ?? [],
          status: "loading",
          error: null,
          filterKey: workerFilterKey,
        },
      }));

      try {
        const response = await dispatch(GetWorkersForClientInductionReport(payload));

        if (response?.status === 401) {
          handleUnauthorizedAccess();
          setRowWorkersState((prev) => ({
            ...prev,
            [rowKey]: {
              data: [],
              status: "error",
              error: "Unauthorized",
              filterKey: workerFilterKey,
            },
          }));
          return;
        }

        if (!response?.success) {
          setRowWorkersState((prev) => ({
            ...prev,
            [rowKey]: {
              data: [],
              status: "error",
              error: response?.message || "Unable to load workers",
              filterKey: workerFilterKey,
            },
          }));
          return;
        }

        const rawWorkers = Array.isArray(response?.data?.workers)
          ? response.data.workers
          : Array.isArray(response?.data?.rows)
          ? response.data.rows
          : Array.isArray(response?.data)
          ? response.data
          : [];

        setRowWorkersState((prev) => ({
          ...prev,
          [rowKey]: {
            data: rawWorkers,
            status: "success",
            error: null,
            filterKey: workerFilterKey,
          },
        }));
      } catch (error) {
        setRowWorkersState((prev) => ({
          ...prev,
          [rowKey]: {
            data: [],
            status: "error",
            error: error?.message || "Unable to load workers",
            filterKey: workerFilterKey,
          },
        }));
      }
    },
    [
      dispatch,
      handleUnauthorizedAccess,
      normalisedWorkerIds,
      workerFilterKey,
    ]
  );

  const toggleRowExpansion = useCallback(
    (rowKey, rowItem) => {
      const isCurrentlyExpanded = expandedRows.includes(rowKey);

      if (isCurrentlyExpanded) {
        setExpandedRows((prev) => prev.filter((key) => key !== rowKey));
        return;
      }

      setExpandedRows((prev) => [...prev, rowKey]);

      const existingState = rowWorkersState[rowKey];
      const shouldFetch =
        !existingState ||
        existingState.status === "error" ||
        existingState.filterKey !== workerFilterKey ||
        existingState.status === undefined;

      if (shouldFetch && existingState?.status !== "loading") {
        fetchWorkersForRow(rowKey, rowItem);
      }
    },
    [expandedRows, rowWorkersState, workerFilterKey, fetchWorkersForRow]
  );

  const handlePageChange = ({ selected }) => {
    SetgetAllinvitedData((prevalue) => {
      return {
        ...prevalue,
        ["page"]: selected + 1,
      };
    });
  };

  const updateFilter = (fieldName, value) => {
    if (fieldName === "status") {
      SetgetAllinvitedData((prevalue) => {
        return {
          ...prevalue,
          [fieldName]: value
            ? value.charAt(0).toLowerCase() + value.slice(1)
            : "",
          ["page"]: 1,
          ["limit"]: 10,
        };
      });
    } else if (fieldName === "worker_ids") {
      SetgetAllinvitedData((prevalue) => {
        return {
          ...prevalue,
          [fieldName]: Array.isArray(value) ? value : [],
          ["page"]: 1,
          ["limit"]: 10,
        };
      });
      setExpandedRows([]);
      setRowWorkersState({});
    } else {
      SetgetAllinvitedData((prevalue) => {
        return {
          ...prevalue,
          [fieldName]: value,
          ["page"]: 1,
          ["limit"]: 10,
        };
      });
    }
  };

  const generateClientInductions = async () => {
    try {
      setIsGenerating(true);
      console.log("Calling backend to generate the report...");

      const response = await dispatch(
        TriggerClientInductionReport(getAllinvitedData)
      );

      if (response?.message) {
        console.log("✅ Report generation triggered successfully");
        notify.show(
          response?.message ||
          "Clients Inductions report generated successfully",
          "success",
          3000
        );
        // Data will be fetched by the existing useEffect GET call
        fetchReportData({ forceRefresh: true });
      } else if (response?.status === 401) {
        handleUnauthorizedAccess();
        notify.show(
          "Unable to generate report due to authorization error.",
          "error",
          3000
        );
      } else {
        console.error("⚠️ Failed to trigger report generation");
        notify.show(
          "Unable to generate report. Please try again.",
          "error",
          3000
        );
      }
    } catch (error) {
      console.error("❌ Error generating client inductions:", error);
      notify.show("Error generating report. Please try again.", "error", 3000);
    } finally {
      setIsGenerating(false);
    }
  };

  const csvHeaders = [
    { label: "ID", key: "id" },
    { label: "Contractor", key: "contractor" },
    { label: "Worker ID", key: "employee_id" },
    { label: "Name", key: "name" },
    { label: "Occupation", key: "occupation" },
    { label: "Worker Status", key: "worker_status" },
    { label: "Induction Status", key: "induction_status" },
    { label: "Date Completed", key: "date_completed" },
    { label: "Expiry Date", key: "expiry_date" },
  ];

  // Pre-process CSV data to format date fields using Moment.js.

  function getBase64ImageFromUrl(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      // Enable cross-origin loading if necessary
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = (error) => reject(error);
      img.src = url;
    });
  }

  const GetPDFAllData = async () => {
    setPdfDownloadSuccessDialog(true);
    let Payload = {
      search: getAllinvitedData?.search,
      client_org_ids: getAllinvitedData?.client_org_ids,
      provider_org_ids: getAllinvitedData?.provider_org_ids,
      worker_ids: getAllinvitedData?.worker_ids,
      status: getAllinvitedData?.status,
      inductionType: getAllinvitedData?.inductionType,
      sort: getAllinvitedData?.sort,
      order: getAllinvitedData?.order,
      publish_date_range: getAllinvitedData?.publish_date_range,
      com_ind_ids: getAllinvitedData?.com_ind_ids,
      site_ind_ids: getAllinvitedData?.site_ind_ids,
      state_ids: getAllinvitedData?.state_ids,
      site_ids: getAllinvitedData?.site_ids,
      expired_only: getAllinvitedData?.expired_only,
      expiry_date_range: getAllinvitedData?.expiry_date_range,
    };

    try {
      const response = await dispatch(GenerateClientInductionReport(Payload));
      if (response.success) {
        setPdfDownloadSuccessDialog(true);
        return response.data; // Return the response data
      } else if (response?.status === 401) {
        handleUnauthorizedAccess();
      }
    } catch (error) {
      console.error("Error fetching PDF data:", error);
      setPdfDownloadSuccessDialog(true);
    } finally {
      setPdfDownloadSuccessDialog(true);
    }
    return null; // Return null if the request is not successful
  };

  const handleExport = async (format) => {
    setSuccessText(format);
    try {
      // Wait for data from GetPDFAllData
      const allReportData = await GetPDFAllData();

      if (!allReportData) {
        setCheckPdfLoad(false);
        console.error("Failed to fetch report data.");
        return;
      }
      
      const payload = {
        search: getAllinvitedData?.search,
        client_org_ids: getAllinvitedData?.client_org_ids,
        provider_org_ids: getAllinvitedData?.provider_org_ids,
        worker_ids: getAllinvitedData?.worker_ids,
        status: getAllinvitedData?.status,
        inductionType: getAllinvitedData?.inductionType,
        sort: getAllinvitedData?.sort,
        order: getAllinvitedData?.order,
        publish_date_range: getAllinvitedData?.publish_date_range,
        com_ind_ids: getAllinvitedData?.com_ind_ids,
        site_ind_ids: getAllinvitedData?.site_ind_ids,
        state_ids: getAllinvitedData?.state_ids,
        site_ids: getAllinvitedData?.site_ids,
        expired_only: getAllinvitedData?.expired_only,
        expiry_date_range: getAllinvitedData?.expiry_date_range,
        isExport: true,
      };

      const workerResponse = await dispatch(GetWorkersForClientInductionReport(payload));
      const allWorkers = workerResponse?.success ? workerResponse.data.workers : [];

      setCheckPdfLoad(false);

      const nestedData = [];
      const inductionReport = allReportData?.inductionReport || [];

      inductionReport.forEach((provider) => {

        const workers = allWorkers.filter(w => {
            const sameProvider = String(w.provider_org_id) === String(provider.provider_org_id);
            const provCompId = provider.company_induction_id;
            const provSiteId = provider.site_induction_id;
            const sameCompany = w.company_induction_id != null && provCompId != null && String(w.company_induction_id) === String(provCompId);
            const sameSite = w.site_induction_id != null && provSiteId != null && String(w.site_induction_id) === String(provSiteId);
            return sameProvider && (sameCompany || sameSite);
        });

        nestedData.push({
            isProvider: true,
            id: provider.provider_org_id,
            contractor: provider.provider_name,
            employee_id: "",
            name: "",
            occupation: "",
            worker_status: "",
            induction_status: "",
            date_completed: "",
            expiry_date: "",
        });

        workers.forEach(w => {
            nestedData.push({
                isProvider: false,
                id: "",
                contractor: "",
                employee_id: (() => {
                  const id = w.employee_id || w.individual_id || w.worker_id;
                  if (!id) return "-";
                  const idStr = String(id).toUpperCase();
                  if (idStr.startsWith("E-")) return id;
                  if (idStr.startsWith("E")) return `E-${idStr.substring(1)}`;
                  return `E-${id}`;
                })(),
                name: w.worker_name,
                occupation: w.occupation || "",
                worker_status: w.worker_status,
                induction_status: w.induction_status || "Not inducted",
                date_completed: w.completion_date ? moment(w.completion_date).format("DD/MM/YYYY") : "-",
                expiry_date: (w.completion_date && w.valid_days) ? moment(w.completion_date).add(w.valid_days, 'days').format("DD/MM/YYYY") : "-",
            });
        });
      });

      if (format === "csv") {
        setProcessedCsvData(
          nestedData.map((item) => {
            return csvHeaders.reduce((newItem, header) => {
              newItem[header.key] = item[header.key] ?? "-";
              return newItem;
            }, {});
          })
        );
      } else if (format === "excel") {
        // Create a header row using the labels from csvHeaders.
        const headerRow = csvHeaders.map((header) => header.label);

        const dataRows = nestedData.map((item) =>
          csvHeaders.map((header) =>
            item[header.key] === undefined || item[header.key] === null || item[header.key] === ""
              ? "-"
              : item[header.key]
          )
        );

        // Combine header and data rows.
        const exportData = [headerRow, ...dataRows];

        // Convert the AOA to a worksheet.
        const ws = XLSX.utils.aoa_to_sheet(exportData);

        // Step 1: Set column widths for better readability in Excel/LibreOffice.
        const widthByKey = {
          id: 16,
          contractor: 35,
          employee_id: 16,
          name: 24,
          occupation: 20,
          worker_status: 16,
          induction_status: 18,
          date_completed: 18,
          expiry_date: 18,
        };
        ws["!cols"] = csvHeaders.map((h) => ({
          wch: widthByKey[h.key] || Math.max(12, String(h.label || "").length + 2),
        }));

        // Step 2: Best-effort wrap text (depends on XLSX writer support).
        const ref = ws["!ref"];
        if (ref) {
          const range = XLSX.utils.decode_range(ref);
          for (let r = range.s.r; r <= range.e.r; r += 1) {
            for (let c = range.s.c; c <= range.e.c; c += 1) {
              const addr = XLSX.utils.encode_cell({ r, c });
              const cell = ws[addr];
              if (!cell) continue;
              cell.s = cell.s || {};
              cell.s.alignment = {
                ...(cell.s.alignment || {}),
                wrapText: true,
                vertical: "top",
              };
            }
          }
        }

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Save the Excel file.
        XLSX.writeFile(wb, "workers_inductions_report.xlsx", { cellStyles: true });
      } else if (format === "pdf") {
        const doc = new jsPDF("l"); // Set to landscape mode
        const today = moment().format("DD/MM/YYYY");

        // Set font and add date (top left)
        doc.setFontSize(12);
        doc.text(today, 14, 15);

        // Add title in center
        const title = "Client Induction List";
        doc.setFontSize(16);
        const pageWidth = doc.internal.pageSize.getWidth();
        const titleWidth = doc.getTextWidth(title);
        const titleX = (pageWidth - titleWidth) / 2;
        doc.text(title, titleX, 15);

        // Convert PNG image to Base64
        const logoUrl = logoPDF;
        let logoData;
        try {
          logoData = await getBase64ImageFromUrl(logoUrl);
        } catch (error) {
          console.error("Error converting image to Base64", error);
        }

        // Add logo image at top right if available
        if (logoData) {
          const imageWidth = 40; // Adjust dimensions as needed
          const imageHeight = 10;
          const marginRight = 15;
          doc.addImage(
            logoData,
            "PNG",
            pageWidth - imageWidth - marginRight,
            10,
            imageWidth,
            imageHeight
          );
        }

        let startY = 25;

        // Group inductionReport by client, then provider
        const clientMap = new Map();
        inductionReport.forEach((row) => {
          const clientKey = String(row.client_org_id);
          if (!clientMap.has(clientKey)) {
            clientMap.set(clientKey, {
              client_org_id: row.client_org_id,
              client_name: row.client_name,
              providers: [],
            });
          }
          clientMap.get(clientKey).providers.push(row);
        });

        const clients = Array.from(clientMap.values());

        clients.forEach((client, clientIdx) => {
          // ---- Client header ----
          doc.setFontSize(13);
          doc.setFont(undefined, "bold");
          doc.text(`Client: ${client.client_name || "-"}`, 14, startY);
          startY += 8;

          client.providers.forEach((provider, provIdx) => {
            const pageHeight = doc.internal.pageSize.getHeight();
            if (startY > pageHeight - 40) {
              doc.addPage("l");
              startY = 20;
            }

            // ---- Provider header ----
            doc.setFontSize(11);
            doc.setFont(undefined, "bold");
            doc.text(`Provider: ${provider.provider_name || "-"}`, 20, startY);
            doc.text(`Provider ID: ${provider.provider_org_id || "-"}`, 115, startY);
            startY += 7;
            doc.setFont(undefined, "normal");

            const workers = allWorkers.filter(w => {
              const sameProvider = String(w.provider_org_id) === String(provider.provider_org_id);
              const provCompId = provider.company_induction_id;
              const provSiteId = provider.site_induction_id;
              const sameCompany = w.company_induction_id != null && provCompId != null && String(w.company_induction_id) === String(provCompId);
              const sameSite = w.site_induction_id != null && provSiteId != null && String(w.site_induction_id) === String(provSiteId);
              return sameProvider && (sameCompany || sameSite);
            });

            if (workers.length > 0) {
              const workerHead = [["Worker ID", "Name", "Occupation", "Worker Status", "Induction Status", "Date Completed", "Expiry Date"]];
              const workerBody = workers.map(w => {
                const empIdRaw = w.employee_id || w.individual_id || w.worker_id;
                let formattedId = "-";
                if (empIdRaw) {
                  const idStr = String(empIdRaw).toUpperCase();
                  if (idStr.startsWith("E-")) {
                    formattedId = String(empIdRaw);
                  } else if (idStr.startsWith("E")) {
                    formattedId = `E-${idStr.substring(1)}`;
                  } else {
                    formattedId = `E-${empIdRaw}`;
                  }
                }

                return [
                  formattedId,
                  w.worker_name || "-",
                  w.occupation || "-",
                  w.worker_status || "-",
                  w.induction_status || "Not inducted",
                  w.completion_date ? moment(w.completion_date).format("DD/MM/YYYY") : "-",
                  (w.completion_date && w.valid_days) ? moment(w.completion_date).add(w.valid_days, 'days').format("DD/MM/YYYY") : "-",
                ];
              });

              doc.autoTable({
                head: workerHead,
                body: workerBody,
                startY,
                styles: { fontSize: 9, overflow: "linebreak", cellPadding: 2, valign: "top" },
                headStyles: { fillColor: "#E5F3FE", textColor: "#464A53", overflow: "linebreak" },
                rowPageBreak: "avoid",
                margin: { left: 20 },
              });
              startY = doc.lastAutoTable.finalY + 10;
            } else {
              startY += 4;
            }
          });

          // Extra gap between clients
          startY += 6;
          if (startY > doc.internal.pageSize.getHeight() - 30 && clientIdx < clients.length - 1) {
            doc.addPage("l");
            startY = 20;
          }
        });

        // Save the PDF
        doc.save("workers_inductions_report.pdf");
      }
    } catch (error) {
      console.error("Error exporting data:", error);
    }
  };

  const closeDownloadSuccessPdf = () => {
    setPdfDownloadSuccessDialog(false);
    setTimeout(() => {
      setCheckPdfLoad(true);
    }, 1000);
  };

  useEffect(() => {
    if (processedCsvData.length > 0) {
      csvLinkRef.current.link.click();
    }
  }, [processedCsvData]); // Runs when processedCsvData updates

  return (
    <React.Fragment>
      <div className="flex justify-between mb-5 border-b border-gray-200 pb-5">
        <Heading>Clients Inductions</Heading>
        <div className="flex gap-3">
          {/* 🟦 Generate Button */}
          <button
            onClick={generateClientInductions}
            disabled={isGenerating}
            className="bg-[#5786CC] text-white text-xs px-3 py-1 rounded-md transition ml-2 flex items-center justify-center min-w-[94px] disabled:opacity-60 disabled:cursor-not-allowed hover:bg-[#3f6ab4]"
          >
            {isGenerating ? <ThreeDotLoader /> : "Generate"}
          </button>

          {/* <BtnLight className="h-10 w-10 flex items-center justify-center gap-2 text-12">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.40156 2.8778C9.59363 2.48869 9.68967 2.29413 9.82004 2.23197C9.93347 2.17789 10.0653 2.17789 10.1787 2.23197C10.3091 2.29413 10.4051 2.48869 10.5972 2.8778L12.4194 6.56944C12.4761 6.68432 12.5045 6.74176 12.5459 6.78635C12.5826 6.82584 12.6266 6.85783 12.6754 6.88056C12.7306 6.90623 12.794 6.91549 12.9208 6.93402L16.9968 7.5298C17.4261 7.59253 17.6407 7.6239 17.74 7.72874C17.8264 7.81995 17.8671 7.94529 17.8506 8.06985C17.8317 8.21302 17.6763 8.36436 17.3656 8.66702L14.4172 11.5387C14.3253 11.6282 14.2794 11.673 14.2497 11.7263C14.2235 11.7734 14.2066 11.8252 14.2001 11.8788C14.1928 11.9393 14.2036 12.0025 14.2253 12.129L14.921 16.1851C14.9944 16.6129 15.031 16.8269 14.9621 16.9538C14.9021 17.0642 14.7955 17.1417 14.6719 17.1646C14.5299 17.1909 14.3378 17.0899 13.9536 16.8879L10.3097 14.9716C10.1961 14.9119 10.1394 14.882 10.0796 14.8703C10.0266 14.8599 9.97213 14.8599 9.91918 14.8703C9.85937 14.882 9.8026 14.9119 9.68906 14.9716L6.04512 16.8879C5.66095 17.0899 5.46886 17.1909 5.32683 17.1646C5.20325 17.1417 5.09662 17.0642 5.03663 16.9538C4.96768 16.8269 5.00437 16.6129 5.07774 16.1851L5.77342 12.129C5.79511 12.0025 5.80595 11.9393 5.79862 11.8788C5.79212 11.8252 5.77528 11.7734 5.74902 11.7263C5.71937 11.673 5.67341 11.6282 5.5815 11.5387L2.63315 8.66702C2.3224 8.36436 2.16703 8.21302 2.14812 8.06985C2.13167 7.94529 2.17231 7.81995 2.25872 7.72874C2.35804 7.6239 2.57266 7.59253 3.00189 7.5298L7.07794 6.93402C7.2047 6.91549 7.26808 6.90623 7.32328 6.88056C7.37215 6.85783 7.41615 6.82584 7.45284 6.78635C7.49427 6.74176 7.52262 6.68432 7.57933 6.56944L9.40156 2.8778Z"
                stroke="#344054"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </BtnLight> */}
          {/* <BtnLight className="h-10 w-40 flex items-center justify-center gap-2 text-12">
            Save as custom report
          </BtnLight> */}

          <div className="export-dropdow">
            <Dropdown title="Export" className="dropdown-btn">
              <Dropdown.Item
                eventKey="a"
                onClick={() => handleExport("csv")}
                className="text-gray-900 font font-medium"
              >
                CSV
              </Dropdown.Item>
              <Dropdown.Item
                eventKey="b"
                onClick={() => handleExport("excel")}
                className="text-gray-900 font font-medium"
              >
                Excel
              </Dropdown.Item>
              <Dropdown.Item
                eventKey="c"
                onClick={() => handleExport("pdf")}
                className="text-gray-900 font font-medium"
              >
                PDF
              </Dropdown.Item>
            </Dropdown>
            {/* HIDDEN CSVLink - clicked programmatically for CSV export */}
            {processedCsvData?.length > 0 && (
              <CSVLink
                data={processedCsvData}
                headers={csvHeaders}
                filename="workers_inductions_report.csv"
                className="hidden"
                ref={csvLinkRef}
                target="_blank"
              />
            )}
          </div>
        </div>
      </div>
      <div className="flex gap-1 cstm-dropdown">
        <div>
          <ClientMultiSelectDropdown
            title="Client"
            updateFilter={updateFilter}
          />
        </div>
        <div>
          <AllProviderMultiSelectDropdown
            title="Provider"
            updateFilter={updateFilter}
            client_org_ids={getAllinvitedData?.client_org_ids}
          />
        </div>
        <div>
          <WorkerMultiSelectDropdown
            title="Worker"
            updateFilter={updateFilter}
            selectedWorkerIds={getAllinvitedData?.worker_ids}
            clientOrgIds={getAllinvitedData?.client_org_ids}
            providerOrgIds={getAllinvitedData?.provider_org_ids}
          />
        </div>
        <div>
          <InductionMultiSelectDropdown
            title="Induction"
            updateFilter={updateFilter}
            provider_org_ids={getAllinvitedData?.provider_org_ids}
            client_org_ids={getAllinvitedData?.client_org_ids}
          />
        </div>
        <div>
          <StatusMultiSelectDropdown
            title={"Status"}
            statusData={["active", "draft", "archived"]}
            updateFilter={updateFilter}
          />
        </div>
        <div>
          <SiteMultiSelectDropdown title={"Site"} updateFilter={updateFilter} />
        </div>
        <div>
          <MainOfficeStateMultiSelectDropdown title={"State"} updateFilter={updateFilter} />
        </div>
        <div>
          <DateMultiSelectDropdown
            title={"Publish date"}
            type={"publish_date_range"}
            setKey={setKey}
            dateMinMax={dateMinMax}
            updateFilter={updateFilter}
          />
        </div>
        <div>
          <DateMultiSelectDropdown
            title={"Expiry date"}
            type={"expiry_date_range"}
            setKey={setKey}
            dateMinMax={dateMinMax}
            updateFilter={updateFilter}
          />
        </div>
        <div className="flex items-center gap-2 px-2">
          <input
            type="checkbox"
            id="expired_only"
            checked={getAllinvitedData.expired_only || false}
            onChange={(e) => updateFilter("expired_only", e.target.checked)}
            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
          />
          <label htmlFor="expired_only" className="text-sm font-medium text-gray-700 cursor-pointer whitespace-nowrap">
            Select only Expired
          </label>
        </div>
      </div>

      <div
        className="flex border border-gray-100 rounded-xl p-6 mt-5 gap-6 items-center justify-between
"
      >
        <PieChart chartData={reportData?.staticsGraph} />
        <ActivityGauge chartData={reportData?.staticsGraph} />
        <ProgressCircle chartData={reportData?.staticsGraph} />
      </div>
      <ClientInductionList
        data={reportData}
        handleSort={handleSort}
        getAllinvitedData={getAllinvitedData}
        expandedRows={expandedRows}
        toggleRowExpansion={toggleRowExpansion}
        buildRowKey={buildRowKey}
        rowWorkersState={rowWorkersState}
      />
      {!loadData && (
        <div>
          <ThreeDotBouncing />
        </div>
      )}

      {loadData && (
        <div className="flex justify-between mt-3">
          <Pagination
            totalCount={reportData?.total || 0}
            pageNumber={getAllinvitedData.page}
            displayPage={reportData?.inductionReport?.length || 0}
            UpdatePageLimit={SetgetAllinvitedData}
            allfilters={getAllinvitedData}
          />
          {reportData?.total > 0 && (
            <ReactPaginate
              className="flex justify-content-end p-2 align-items-center pagination-wrap"
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              previousLinkClassName={"prev-link"}
              nextLinkClassName={"page-link"}
              breakLinkClassName={"prev-link"}
              previousClassname={"px-4 rounded-md bg-blue-700 text-white"}
              nextClassname={"px-4 rounded-md bg-blue-700 text-white"}
              pageLinkClassName={"px-4 rounded-md"}
              activeLinkClassName={"w-9 h-9 bg-blue-700 text-white"}
              disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
              renderOnZeroPageCount={null}
              forcePage={getAllinvitedData?.page - 1}
            />
          )}
        </div>
      )}
      <Dialog
        isOpen={pdfDownloadSuccessDialog}
        onClose={closeDownloadSuccessPdf}
        onRequestClose={closeDownloadSuccessPdf}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          {!checkPdfLoad && (
            <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
              <svg
                width="49"
                height="49"
                viewBox="0 0 49 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.894531"
                  y="0.585938"
                  width="48"
                  height="48"
                  rx="24"
                  fill="#D1FADF"
                />
                <path
                  d="M26.8945 14.8555V18.986C26.8945 19.5461 26.8945 19.8261 27.0035 20.04C27.0994 20.2282 27.2524 20.3811 27.4405 20.477C27.6545 20.586 27.9345 20.586 28.4945 20.586H32.6251M28.8945 25.5859H20.8945M28.8945 29.5859H20.8945M22.8945 21.5859H20.8945M26.8945 14.5859H21.6945C20.0144 14.5859 19.1743 14.5859 18.5326 14.9129C17.9681 15.2005 17.5091 15.6595 17.2215 16.224C16.8945 16.8657 16.8945 17.7058 16.8945 19.3859V29.7859C16.8945 31.4661 16.8945 32.3062 17.2215 32.9479C17.5091 33.5124 17.9681 33.9713 18.5326 34.259C19.1743 34.5859 20.0144 34.5859 21.6945 34.5859H28.0945C29.7747 34.5859 30.6148 34.5859 31.2565 34.259C31.821 33.9713 32.2799 33.5124 32.5676 32.9479C32.8945 32.3062 32.8945 31.4661 32.8945 29.7859V20.5859L26.8945 14.5859Z"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          )}
          {checkPdfLoad && (
            <div>
              <ThreeDotBouncing />
            </div>
          )}
          <p className="text-base text-gray-900 font-semibold text-center mt-4">
            {checkPdfLoad
              ? `${
                  successText.charAt(0).toUpperCase() + successText.slice(1)
                } downloading..`
              : `${
                  successText.charAt(0).toUpperCase() + successText.slice(1)
                } downloaded successfully!`}
          </p>
        </div>
        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={() => closeDownloadSuccessPdf()}>Close</BtnLight>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default ClientsInductions;
